import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type QuizPerformanceFragment = { id: string, entityId: string, isSubmitted: boolean, score?: number | null, correctAnswersCount?: number | null, status: Types.PerformanceStatusEnum, startedOn?: string | null, timeSpent: number, result?: Types.QuizResultEnum | null, maxScore?: number | null, attemptId: string, updatedAt: string, userContentFeedback?: { id: string } | null, maxSubmissionDetails?: { score?: number | null, timeSpent: number, maxScore?: number | null } | null, attempts?: Array<{ attemptId: string, score?: number | null, correctAnswersCount?: number | null, status: Types.PerformanceStatusEnum, maxScore?: number | null, timeSpent: number, isSubmitted: boolean, updatedAt?: string | null, result?: Types.QuizResultEnum | null, scorePercentage?: number | null }> | null, user?: { id: string, name?: string | null } | null };


export type QuizPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizPerformance on QuizPerformanceType {
  id
  entityId
  isSubmitted
  score
  correctAnswersCount
  status
  startedOn
  timeSpent
  result
  userContentFeedback {
    id
  }
  maxSubmissionDetails {
    score
    timeSpent
    maxScore
  }
  maxScore
  attemptId
  updatedAt
  attempts {
    attemptId
    score
    correctAnswersCount
    status
    maxScore
    timeSpent
    isSubmitted
    updatedAt
    result
    scorePercentage
  }
  user {
    id
    name
  }
}
    `;